import { UntypedFormGroup } from '@angular/forms';

export interface DynamicLayout {
  json: Object;
  paths: Array<string>;
  groups: Object;
  layout?: { [index: string]: Layout | LayoutOptions };
  data?: Object;
}

export interface SplitPath {
  newPath: string[];
  lastKey: string;
}

export interface Attributes {
  pathToAdd?: string;
  keyToAdd?: string;
  pathToData?: string;
  add?: boolean;
  optional?: boolean;
}

export interface LayoutOptions {
  type?: LayoutType;
  label?: string;
  dataType?: DataTypes;
  validators?: { [index: string]: any };
  attributes?: Attributes;
  key?: any;
  value?: Layout | { [index: string]: any };
}

export interface Layout {
  placeholder?: string;
  type: LayoutType;
  label: string;
  dataType?: DataTypes;
  validators?: { [index: string]: any };
  attributes?: Attributes;
  description?: any;
}

export interface Attributes {
  placeholder?: string;
  optionsGroup?: Object;
  options?: Object;
  data?: boolean;
  type?: string;
  delete?: boolean;
  class?: string;
  readonly?: boolean;
  value?: string;
  add?: boolean;
  header?: string;
}

export type LayoutType =
  | 'textarea'
  | 'text'
  | 'dropdownGroup'
  | 'array'
  | 'dropdown'
  | 'next'
  | 'dropdownApi'
  | 'checkbox-single'
  | 'autocomplete'
  | 'selector'
  | 'image'
  | 'asset';

export interface MyFormBuilder {
  form: UntypedFormGroup;
}

const ATTRIBUTES = 'attributes';
// const ADD_ATTRIBUTE = 'add';
const LIST_KEY = '#';
const PLACEHOLDER = '$';
const PATH_SEPARATOR = '.';
const DATA_ATTRIBUTE = 'data';
const SPLIT_PATH = '_';
const DEFAULT_SELECT_OPTION_VALUE = '-';
const DEFAULT_SELECT_OPTION_DESCRIPTION = '-- select an option --';

export type DataTypes = 'keyValue' | 'keyObject' | 'array' | 'item' | 'keyword';

export const formBuilderConstants = {
  ATTRIBUTES,
  LIST_KEY,
  PLACEHOLDER,
  PATH_SEPARATOR,
  DATA_ATTRIBUTE,
  SPLIT_PATH,

  DEFAULT_SELECT_OPTION_VALUE,
  DEFAULT_SELECT_OPTION_DESCRIPTION,
};
